import {Injectable} from '@angular/core';
import {ContactType} from '@app/models/abstract-contact.model';
import {CallModel} from '@app/models/call.model';
import {ContactModel} from '@app/models/contact.model';
import {GtAuthenticationService} from '@app/services/gt-authentication.service';
import {GtDirectoryService} from '@app/services/gt-directory.service';
import {BuilderFactory} from '@app/shared/utils/builder.factory';
import {GtPhoneNumberUtil} from '@app/shared/utils/gt-phone-number.util';
import {WhitepagesService} from '@gt-api';
import {TranslateService} from '@ngx-translate/core';
import {Observable, of} from 'rxjs';
import {catchError, map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class GtWhitepagesService {
  private whitePageStore = new Map<string, Array<string>>();

  constructor(
    private whitepages: WhitepagesService,
    private authenticationService: GtAuthenticationService,
    private directoryService: GtDirectoryService,
    private translate: TranslateService
  ) {}

  search(query: string): Observable<Array<string>> {
    if (this.whitePageStore.has(query)) {
      return of(this.whitePageStore.get(query));
    }
    return this.whitepages.search1(query, 'jCard').pipe(
      catchError(error => {
        console.log('Error during whitepage lookup ', error);
        return [];
      }),
      map(r => {
        if (r.code !== 200) {
          return [];
        }
        this.whitePageStore.set(query, r.results);
        return r.results;
      })
    );
  }

  lookupCall(newCall: CallModel) {
    if (!newCall.lookupDone) {
      const fullNumber = newCall.fullNumber;
      if (fullNumber === 'anonymous' || !fullNumber || fullNumber === '') {
        this.setContactDataForCall(newCall, undefined);
        newCall.caller.name = this.translate.instant('global.hidden_number');
        newCall.lookupDone = true;
      } else {
        this.directoryService.getContactByFullNumber(this.authenticationService.oname, fullNumber).subscribe(
          contact => {
            newCall.caller = contact;
            newCall.lookupDone = true;
          },
          () => {
            if (this.whitePageStore.has(fullNumber)) {
              this.setContactDataForCall(newCall, this.whitePageStore.get(fullNumber));
              newCall.lookupDone = true;
            } else {
              this.search(fullNumber).subscribe((response: string[]) => {
                this.setContactDataForCall(newCall, response);
                newCall.lookupDone = true;
              });
            }
          }
        );
      }
    }
  }

  private setContactDataForCall(newCall: CallModel, results: string[]) {
    if (results && results.length > 0) {
      newCall.caller = ContactModel.convertVCardModel(results[0], newCall.fullNumber);
    } else {
      newCall.caller = BuilderFactory.createBuilder(ContactModel)
        .type(ContactType.Contact)
        .id(-1)
        .status('')
        .name('')
        .statusIcon('person_outline')
        .phoneNumber(GtPhoneNumberUtil.toBackend(newCall.fullNumber))
        .build();
    }
  }
}
